<template>
  <div class="container">
    <img src="../../../static/images/index/bg.png" class="bgImg" />
    <template v-if="sysDynamics && sysDynamics.Content">
      <div
        class="systemMsg"
        @click.stop="
          toSysDynamics(
            sysDynamics.PostType,
            sysDynamics.PostId,
            sysDynamics.ShareType,
            sysDynamics.ShareId
          )
        "
      >
        <span class="iconfont icon-laba" style="font-size: 14px"></span>
        <van-notice-bar
          scrollable
          :text="sysDynamics.Content"
          color="#B17733"
          :speed="50"
        ></van-notice-bar>
        <span class="iconfont icon-right" style="font-size: 10px"></span>
      </div>
    </template>
    <div class="module-box">
      <router-link class="m_item" to="/exhibitionIntroduce">
        <div class="mDiv red"><span class="iconfont icon-guangyazhan"></span></div>
        <span>展会介绍</span>
      </router-link>
      <router-link class="m_item" to="/expoLatestBooth">
        <div class="mDiv purple"><span class="iconfont icon-buju"></span></div>
        <span>最新展位图</span>
      </router-link>
      <router-link class="m_item" to="/expoExhibitor">
        <div class="mDiv yellow"><span class="iconfont icon-mingdan"></span></div>
        <span>参展商名单</span>
      </router-link>
      <!-- <div class="m_item" @click="toAttendinfo">
        <div class="mDiv green"><span class="iconfont icon-dengjixinxi"></span></div>
        <span>观众预登记</span>
      </div> -->
      <router-link class="m_item" to="/attendinfo">
        <div class="mDiv green"><span class="iconfont icon-dengjixinxi"></span></div>
        <span>观众预登记</span>
      </router-link>
      <router-link class="m_item" to="/expoActivity">
        <div class="mDiv blue"><span class="iconfont icon-qiqiu" style="font-size:25px"></span></div>
        <span>大会活动</span>
      </router-link>
      <router-link class="m_item" to="/expoVisitGuide">
        <div class="mDiv blue"><span class="iconfont icon-zhinan1"></span></div>
        <span>观展指南</span>
      </router-link>
      <router-link class="m_item" to="/expoJoinGuide">
        <div class="mDiv green"><span class="iconfont icon-zhinan"></span></div>
        <span>参展商指南</span>
      </router-link>
      <!-- <router-link class="m_item" to="/expoCar">
        <div class="mDiv red"><span class="iconfont icon-zhanshang"></span></div>
        <span>申领车证</span>
      </router-link> -->
      <mini-program path="/pkgexpo/pages/card/card" class="m_item">
        <div class="mDiv red"><span class="iconfont icon-zhanshang"></span></div>
        <span>参展商证</span>
      </mini-program>
      <router-link class="m_item" to="/expoBuilder">
        <div class="mDiv yellow"><span class="iconfont icon-gongchengshi"></span></div>
        <span>指定搭建商</span>
      </router-link>
      <router-link class="m_item" to="/expoHotel">
        <div class="mDiv purple"><span class="iconfont icon-jiudian" style="font-size:21px"></span></div>
        <span>酒店预订</span>
      </router-link>
    </div>
    <!-- tab栏 -->
    <div class="tab-box">
      <div class="tb_main">
        <div :class="{'act':type==1}" @click="typeClick(1)">广州国际照明展览会<span></span></div>
        <div :class="{'act':type==2}" @click="typeClick(2)">广州国际建筑电气技术展览会<span></span></div>
      </div>
    </div>
    <!-- 知名参展品牌 -->
    <div class="brand-box">
      <div class="title">知名参展品牌</div>
      <div class="swiper">
        <van-swipe
          style="width: 100%; height: 100%"
          @change="swiperBrandChange"
          autoplay="3000"
          interval="2000"
          duration="1000"
          :show-indicators="false"
        >
          <van-swipe-item v-for="(item, index) in brandList" :key="index">
            <div class="b_item">
              <div v-for="(inner, innerIndex) in item.children" :key="innerIndex" @click="toStoreShow(inner.Path)">
                <img :src="inner.Img" />
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
        <!--重置小圆点的样式 -->
        <div class="dots">
          <div v-for="(item, index) in brandList" :key="index">
            <div class="dot" :class="{'active':index == brandCurrent}"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 展区分布 -->
    <div class="distribution-box">
      <div class="title">2025展区展馆分布</div>
      <router-link to="/expoExhibitor">
        <img src="https://cdn.alighting.com/wxopen/cover/fenbu2024.jpg" class="fenbuImg" />
      </router-link>
      <div v-for="(item, index) in exhibitionList" :key="index">
        <div class="region" :class="{'region_b':index%2==0}" v-if="item.List.length>0">
          <div class="area"><span>{{item.Title}}</span></div>
          <div class="exh_list">
            <div v-for="(sitem, sindex) in item.List" :key="sindex">
              <div class="el_item" @click.stop="toShowRoom(sitem.HallNo)">
                <div>{{sitem.HallNoDesc}}</div>
                <div class="overFlowTwo">{{sitem.Desc}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品 -->
    <div class="pro-box">
      <div class="title">展会亮点产品</div>
      <div class="pro_list">
        <div
          v-for="(item, index) in productList"
          :key="index"
          @click="toProduceDetail(item.Path)"
        >
          <img :src="item.Img" />
          <div class="overFlowTwo">{{ item.Title }}</div>
        </div>
      </div>
      <mini-program path="/pages/exhCenter/index/index" class="pro_more">
        <div>
          <div>更多参展展品<span class="iconfont icon-right"></span></div>
        </div>
      </mini-program>
    </div>
  </div>
</template>
<script>
import miniProgram from "@/components/miniProgram";
import { NoticeBar, Swipe, SwipeItem } from "vant";
import { systemNewPost,  mobileAdverts, exhibitionList } from "@/api/index";
export default {
  name: "exhibition",
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-notice-bar": NoticeBar,
    miniProgram,
  },
  data() {
    return {
      sysDynamics: "",
      type: 1, //1光亚展 2电气
      brandList: [], //知名参展品牌
      brandCurrent: 0,
      exhibitionList: [], //展馆列表
      productList: [], //展会亮点产品
    };
  },
  computed: {},
  methods: {
    // 初始化数据
    initType(){
      this.brandList = [];
      this.brandCurrent = 0;
      this.productList = [];
      //知名品牌
      this.getBrandList();
      //展馆列表
      this.getExhibitionList();
      //展会亮点产品
      this.getProductList();
    },
    //动态详情
    toSysDynamics(type, id, stype, sid) {
      // 1图文 2视频 3文章
      if (type == 1) {
        this.$router.push({ path: "/trendDetails", query: { tid: id } });
      } else if (type == 2) {
        this.$router.push({ path: "/videoDetails", query: { vid: id } });
      } else if (type == 3) {
        if (stype == 2) {
          this.$router.push({ path: "/videoDetail", query: { id: sid } });
        } else {
          this.$router.push({ path: "/articleDetail", query: { id: sid } });
        }
      } else { }
    },
    // tab切换
    typeClick: function(type){
      this.type = type;
      this.initType();
    },
    //品牌轮播切换-自制定点
    swiperBrandChange(index) {
      this.brandCurrent = index;
    },
    //知名品牌列表
    getBrandList() {
      mobileAdverts({
        "Type": this.type == 1 ? 1 : 415
      }).then((res) => {
        this.brandList = this.listCheckHandle(res.Data.List);
      });
    },
    //知名品牌列表数据处理
    listCheckHandle(list) {
      var length = list.length;
      var num = Math.ceil(length / 12);
      var List = [];
      for (var i = 0; i < num; i++) {
        var obj = {};
        obj.children = [];
        list.forEach(function (item, index) {
          var data = {};
          data.Img = item.Img;
          data.Title = item.Title;
          data.Path = item.Path;
          if (index < 12) {
            obj.children.push(data);
          }
        });
        List.push(obj);
        list.splice(0, 12);
      }
      return List;
    },
    //跳转展厅
    toStoreShow(path) {
      if (path.indexOf("?") != -1) {
        var mid = path.split("?")[1].split("=")[1];
        this.$router.push({ path: "/storeShow", query: { mid: mid } });
      }
    },
    //获取展馆列表
    getExhibitionList() {
      exhibitionList({
        "IsOrder": 0,
        "IsGEBT": this.type ==1 ? false : true
      }).then((res) => {
        // 处理数据
        var elist = [
          {Title:"A区展馆",List:[]},
          {Title:"B区展馆",List:[]},
          {Title:"D区展馆",List:[]}];
        if(res.Data.List.length>0){
          res.Data.List.forEach((item, index) => {
            if(item.Region==1){
                elist[0].List.push(item)
            }else if(item.Region==2){
                elist[1].List.push(item)
            }else if(item.Region==3){
                elist[2].List.push(item)
            }else{}
          })
        }
        this.exhibitionList = elist;
      });
    },
    //跳转展馆
    toShowRoom(hallNo) {
      this.$router.push({ path: "/expoExhibitor", query: { hallNo: hallNo } });
    },
    //亮点产品
    getProductList() {
      mobileAdverts({ Type: 2 }).then((res) => {
        this.productList = res.Data.List;
      });
    },
    //跳转产品详情
    toProduceDetail(path) {
      if (path.indexOf("?") != -1) {
        var goodId = path.split("?")[1].split("=")[1];
        this.$router.push({ path: "/productDetail", query: { id: goodId } });
      }
    },
    //提示
    // toAttendinfo() {
    //   this.Common.showMsg("2025广州国际照明展览会（光亚展）\n观众预登记通道暂未开启，请耐心等候");
    //   return false;
    // },
  },
  mounted() {
    systemNewPost().then((res) => {
      this.sysDynamics = res.Data;
    });
    this.initType();
  },
};
</script>
<style scoped src="../../../static/css/exhibition.css"></style>
